export default __webpack_public_path__ + "media/components/AdEdit/images/instagram-more-0af9f6656f743bc87f7aef38c9c43675.png";